import React from 'react'
import './bold-text.css'

export const BoldText = ({ text }) => {
    return <div className="bold-text">{text}</div>
}
